<template>
    <div class="container">
        <index
            v-if='indexshow'
            @skipaction='skipaction'>
        </index>
        <share v-if='shareshow' @goindex='goindex'></share>
    </div>
</template>

<script>
import wxShare from '@utils/wxShare';
import share from './components/share';
import index from './components/index';

export default {
    components: {
        share,
        index
    },
    data() {
        return {
            shareshow: false,
            indexshow: true
        };
    },
    methods: {
        videoCanPlay() {
            clearInterval(this.timer);
            setTimeout(() => {
                this.timer = setInterval(() => {
                    this.progress += 1;
                    if (this.progress >= 100) {
                        this.progress = 100;
                        clearInterval(this.timer);
                        this.loading = true;
                    }
                }, 10);
            }, 800);
        },
        skipaction() {
            this.indexshow = false;
            this.shareshow = true;
        },
        goindex() {
            this.indexshow = true;
            this.shareshow = false;
        }
    },
    mounted() {
        wxShare({
            title: '如果朋友圈的好友都说真话...',
            desc: '那也要喜欢自己，你才是你今生的唯一...',
            link: `${location.origin}/shuiyi`,
            imgUrl: 'http://wwj.jijiagames.com/web/act/20190307/sharelogo.png'
        }, () => {
            /* eslint-disable-next-line */
            window._hmt.push(['_trackEvent', '市场3.8节-分享数量', 'H5分享数量', window.location.href]);
        });
        this.timer = setInterval(() => {
            this.progress += 1;
            if (this.progress >= Math.floor((Math.random() * 20) + 50)) {
                clearInterval(this.timer);
                setTimeout(() => {
                    this.videoCanPlay();
                }, 2000);
            }
        }, 15);
    },
    created() {
    }
};
</script>

<style lang="stylus">
</style>
